import React from "react";
import { useNavigate } from "react-router-dom";
import pageNotFoundImage from "../assets/page-not-found.png";
import "./NotFound.css";

const NotFound: React.FC = () => {
	const navigate = useNavigate();

	const handleBackToHome = () => {
		navigate("/upload");
	};

	return (
		<div className="not-found-container">
			<div className="not-found-content">
				{/* Main 404 Image */}
				<div className="not-found-image-container">
					<img
						src={pageNotFoundImage}
						alt="404 Not Found"
						className="not-found-image"
					/>
				</div>

				{/* Error Message */}
				<div className="not-found-message">
					This is not the webpage you're looking for!
				</div>

				{/* Back to Home Button */}
				<button onClick={handleBackToHome} className="not-found-button">
					Back to Home
				</button>
			</div>
		</div>
	);
};

export default NotFound;
